// extracted by mini-css-extract-plugin
export default {"cvvIcon":"CVVIcon-module__cvvIcon--ER5aO"};